import { v4 } from 'uuid'

import { ApiNodeColumn, ApiNodeData } from '@/endpoints/schemas/api-node'

import { ensureValidData } from '../helpers'

export const defaultApiNodeData: Readonly<ApiNodeData> = {
	name: '',
	code: '',
	columns: [],
	columnsLastId: 0,
	objectPermissions: [],
	objectPermissionLastId: 0,
}

export const getInitialApiNodeData = (name: string, code = ''): ApiNodeData => {
	return ensureValidData(
		{
			name,
			code,
		},
		defaultApiNodeData,
	)
}

export const createEmptyColumn = (columns: ApiNodeColumn[]): ApiNodeColumn => ({
	id: -1,
	uuid: v4(),
	order: columns.length,
	name: '',
	mandatory: false,
})
